/* eslint-disable import/prefer-default-export */
export const getIncrementalName = (originalName?: string): string => {
  if (!originalName) {
    return ''
  }
  const lastLeftBracketIndex = originalName.lastIndexOf('(')
  const isEndingWithBracket = originalName[originalName.length - 1] === ')'

  if (lastLeftBracketIndex !== -1 && isEndingWithBracket) {
    const numberStr = originalName.substring(lastLeftBracketIndex + 1, originalName.length - 1)
    const number = parseInt(numberStr, 10)

    if (Number.isInteger(number) && number > 0) {
      const baseName = originalName.substring(0, lastLeftBracketIndex).trim()
      return `${baseName} (${number + 1})`
    }
  }
  return `${originalName} (1)`
}
